<template>
  <div>
    <div class="wrap-style" v-for="(form, idx) in formDataList" :key="(form.deliverykey || '') + '-' + idx">
      <div>
        <span class="company">LINSY</span>
        <span class="company2">林氏</span>
      </div>
      <div class="title">五金箱配送单</div>
      <div class="print-header">
        <div class="header-info">
          <div class="info">
            <div class="item">
              <div class="label">供货方：</div>
              <div class="underline content">{{form.supplier}}</div>
            </div>
            <div class="item">
              <span class="label">收货方：</span>
              <div class="underline content">{{form.consignee}}</div>
            </div>
          </div>
          <div class="info">
            <div class="item">
              <div class="label">出库单号：</div>
              <div class="underline content">{{form.deliverykey}}</div>
            </div>
            <div class="item">
              <div class="label">收货子库：</div>
              <div class="underline content">{{form.subinventory}}</div>
            </div>
          </div>
          <div class="info">
            <div class="item">
              <div class="label">要求送达时间：</div>
              <div class="underline content">{{form.demandDate}}</div>
            </div>
            <div class="item">
              <div class="label">配送地：</div>
              <div class="underline content">{{form.orgAddress}}</div>
            </div>
          </div>
        </div>
        <div class="qrCode">
          <div class="qrCode-border">
            <QrCode id="qrCode" :text="form.deliverykey" width="90" height="90" ref="qrCode" />
          </div>
        </div>
      </div>

      <table border="1" class="table-style" width="100%">
        <tr>
          <td class="tac table-title">序号</td>
          <td class="tac table-title">成品工单号</td>
          <td class="tac table-title">计划单号</td>
          <td class="tac table-title">成品编码</td>
          <td class="tac table-title">成品名称</td>
          <td class="tac table-title">五金箱编码</td>
          <td class="tac table-title">五金箱名称</td>
          <td class="tac table-title">数量</td>
          <td class="tac table-title">配送量</td>
          <td class="tac table-title">单位</td>
          <td class="tac table-title">备注</td>
        </tr>
        <tr v-for="(item, index) in form.lineList" :key="item.wipEntityName + index">
          <td class="tac" width="5%">{{ index + 1 }}</td>
          <td class="tac" width="11%">{{ item.wipEntityName }}</td>
          <td class="tac" width="11%">{{ item.orderNo }}</td>
          <td class="tac" width="11%">{{ item.assemblyItemCode }}</td>
          <td class="tac" width="10%">{{ item.assemblyItemName }}</td>
          <td class="tac" width="11%">{{ item.itemCode }}</td>
          <td class="tac" width="10%">{{ item.itemName }}</td>
          <td class="tac" width="8%">{{ item.qty }}</td>
          <td class="tac" width="8%"></td>
          <td class="tac" width="7%">{{item.uom}}</td>
          <td class="tac" width="8%">{{item.comment}}</td>
        </tr>
      </table>
      <div class="info creator">
        <div class="item">
          <div class="label">制单人：</div>
          <div class="underline content">{{form.createName}}</div>
        </div>
        <div class="item">
          <div class="label">制单时间：</div>
          <div class="underline content">{{form.createTime}}</div>
        </div>
      </div>
      <div class="foot-info">
        <div class="info">
          <div class="item">
            <div class="label">供货方签字（盖章）：</div>
            <div class="underline content">{{form.organizationName}}</div>
          </div>
          <div class="item">
            <span class="label">收货方签字（盖章）：</span>
            <div class="underline content">{{form.callDocNumber}}</div>
          </div>
        </div>
        <div class="info">
          <div class="item">
            <div class="label">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp送货日期：</div>
            <div class="underline content">{{form.organizationName}}</div>
          </div>
          <div class="item">
            <span class="label">收货日期：</span>
            <div class="underline content">{{form.callDocNumber}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index'

export default {
  name: 'HardwareCallMaterialPrint',
  data () {
    return {
      formDataList: []
    }
  },
  components: { QrCode },
  methods: {
    show(data) {
      const list = Array.isArray(data) ? data : (data ? [data] : []);
      this.formDataList = list.map((one) => {
        const normalized = one ? { ...one } : { lineList: [] };
        if (!Array.isArray(normalized.lineList)) {
          normalized.lineList = [];
        }
        return normalized;
      });
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-style{
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 10px;
  table{
    // border: 1px solid #7030a0;
    td{
      // border-style: dotted;
    }
  }
  .title{
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    padding-bottom: 10px;
  }
}
.table-title{
  font-weight: 700;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
  word-break: break-all;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.underline {
  border-bottom: 2px solid #000;
  padding-bottom: 2px;
}
.label{
  min-width: 60px;
  text-align: right;
  margin-right: 5px;
  font-weight: 700;
  font-size: 15px;
}
.print-header{
  display: flex;
  width: 100%;
  .header-info{
    width: calc(100% - 120px)
  }
  .qrCode{
    width: 120px;
    position: relative;
    .qrCode-border{
      position: absolute;
      right: 0;
      top: -10px;
    }
  }
}
.info{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .item{
    display: flex;
  }
  .content{
    min-width: 140px;
  }
}
.creator{
  padding-top: 20px;
}
.tip{
  padding: 10px 50px 10px 50px;
  text-align: center;
  color: #000;
  font-style: italic;
}
.file{
  font-style: italic;
}
.company{
  font-size: 26px;
  font-weight: 700;
  color: #1ba49e;
  margin-right: 10px;
}
.company2{
  font-size: 25px;
  color: #1ba49e;
}
.foot-info{
  margin-top: 100px;
}
</style>
